import { FC, useEffect, useState } from "react";
import CustomPopup from "../../../custom-components/CustomPopup";
import BlockedUsersListButton from "../../resources/components/buttons/BlockedUsersListButton";
import { useTranslation } from "react-i18next";
import PaginatedList from "../../resources/components/PaginatedList";
import { useSelector } from "react-redux";
import { selectBlockedUsersCollection } from "../../../slices/user-slice";
import { DEFAULT_PAGE, RECORDS_PER_PAGE } from "../../../domain/constants";
import { UserServiceImpl } from "../../../services/UserServiceImpl";
import { useAppDispatch } from "../../../custom-hooks/useAppDispatch";
import BlockedUserItem from "./BlockedUserItem";

interface BlockedUsersListPopupProps {}

const BlockedUsersListPopup: FC<BlockedUsersListPopupProps> = ({}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [page, setPage] = useState(0);
    const blockedUsers = useSelector(selectBlockedUsersCollection());
    const dispatch = useAppDispatch();

    const { t } = useTranslation();

    const uploadBlockedUsers = async (resetPage: boolean) => {
        const currentPage = resetPage ? DEFAULT_PAGE : page + 1;
        await dispatch(
            UserServiceImpl.getBlockedUsersThunk({
                page: currentPage,
                limit: RECORDS_PER_PAGE,
            }),
        );
        setPage(currentPage);
    };

    const refreshBlockedUsers = async () => {
        await uploadBlockedUsers(true);
    };

    useEffect(() => {
        if (isVisible) {
            uploadBlockedUsers(true);
        }
    }, [isVisible]);

    return (
        <div>
            <CustomPopup
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                wrapClassName="dmin2:min-w-[846px] di6:min-w-[600px] ti6:min-w-[600px] ti7:min-w-[360px]"
                title={t("common.blockedList")}
                titleClassName="mb-8 dmax2:mb-6 mt-2 dmax2:mt-[10px]"
                buttonElement={<BlockedUsersListButton onClick={() => setIsVisible(true)} />}
                nested
            >
                <div className="w-full flex flex-col max-h-[400px] overflow-y-auto">
                    <PaginatedList
                        entities={blockedUsers}
                        emptyEntitiesContent={
                            <div className="flex flex-col items-start">
                                <p className="H20B dmax2:H16 text-textFaded text-left">
                                    {t("userProfile.blockedUsers.nothingFound")}
                                </p>
                            </div>
                        }
                        uploadCallback={() => uploadBlockedUsers(false)}
                        getItemElement={(user) => (
                            <BlockedUserItem
                                key={`user-${user.id}`}
                                user={user}
                                onUnblockSuccess={refreshBlockedUsers}
                            />
                        )}
                        disableUseEffect
                    />
                </div>
            </CustomPopup>
        </div>
    );
};

export default BlockedUsersListPopup;
